import {App, Button} from "antd";
import {Popover} from "antd";
import {configConfirmModal, HorizonDots} from "@/theme";
import {ReactNode, useState} from "react";
import {PopoverProps} from "antd/es/popover";
import {useRouter} from "next/navigation";
import {myLinks} from "@/lib/routes/myLinks";

type ActionOptionsType = PopoverProps & {
    children: ReactNode
}
const OptionButtonsRoot = ({children, ...rest}: ActionOptionsType) => {
    const [open, setOpen] = useState(false)

    return(
        <Popover
            onOpenChange={()=>{
                setOpen(!open)
            }}
            rootClassName={'options_button'}
            content={(
                <div
                    onClick={(e)=>{
                        e.preventDefault()
                        setOpen(!open)
                    }}
                >
                    {children}
                </div>
            )}
            trigger="click"
            placement={'bottomRight'}
            arrow={false}
            open={open}
            {...rest}
        >
            <Button
                type="text"
                icon={<HorizonDots />}
                onClick={()=>{
                    setOpen(!open)
                }}
            />
        </Popover>
    )
}

type ButtonType = {
    type?: "default" | "danger",
    children: ReactNode
    onClick?: () => void;
    confirm?: any;
}
const OptionButtonRoot = ({type = 'default', children, onClick, confirm}: ButtonType) =>{
    const {modal} = App.useApp();

    return(
        <div
            className={`button ${type}`}
            onClick={async () => {
                if (confirm){
                    // @ts-ignore
                    modal.confirm(configConfirmModal({
                        ...confirm,
                        onOk: () =>{
                            if (onClick){
                                onClick()
                            }
                        }
                    }))
                }else {
                    if (onClick){
                        onClick()
                    }
                }
            }}
        >
            {children}
        </div>
    )
}

type ButtonLinkType = ButtonType & {
    route: string,
    query?: object
}

const OptionButtonLink = ({route, query, children}: ButtonLinkType) =>{
    const router = useRouter()

    return(
        <OptionButtonRoot
            onClick={()=>{
                router.push(myLinks.getUlr(route, query))
            }}
        >
            {children}
        </OptionButtonRoot>
    )
}

export const OptionButton = OptionButtonsRoot as typeof OptionButtonsRoot & {
    Button: typeof OptionButtonRoot;
    ButtonLink: typeof OptionButtonLink;
};

OptionButton.Button = OptionButtonRoot
OptionButton.ButtonLink = OptionButtonLink
